import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import './IVSetting.css'; // 스타일 재사용

function AcbSetting() {
  const settingList = useSelector((state) => state.settingList || {});
  const acbData  = useSelector((state) => state.acbData || {});
  const { commPortList = [], Acb_protocollist = [] } = settingList;

  // 입력폼 상태
  const [inputCommPort, setInputCommPort] = useState('RS485-CH1');
  const [inputAddress, setInputAddress] = useState('1');              // ACB address
  const [inputName, setInputName] = useState('차단기1');
  const [inputProtocol, setInputProtocol] = useState('GIPAM-115FI');
  const [inputIP, setInputIP] = useState('192.168.105.101');
  const [inputPort, setInputPort] = useState('502');

  // 목록/모달
  const [acbList, setAcbList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editItem, setEditItem] = useState(null); // {seq, ...}

  const isEthernet = inputCommPort === 'ETHERNET';

  // 공통 유효성 체크
  const validateBeforeSave = ({ commPort, address, name, protocol, ip, port }) => {
    const addrNum = parseInt(address, 10);
    if (isNaN(addrNum) || addrNum < 1 || addrNum > 65535) {
      alert('장비 ID(acb_address)는 1~65535 범위의 정수여야 합니다.');
      return false;
    }
    if (!name?.trim()) {
      alert('차단기 이름을 입력하세요.');
      return false;
    }
    if (!protocol?.trim()) {
      alert('프로토콜을 선택하세요.');
      return false;
    }
    if (commPort === 'ETHERNET') {
      const portNum = parseInt(port, 10);
      if (isNaN(portNum) || portNum <= 0 || portNum > 65535) {
        alert('이더넷 포트는 1~65535 범위의 정수여야 합니다.');
        return false;
      }
      if (!/^\d{1,3}(\.\d{1,3}){3}$/.test(ip || '')) {
        alert('IP 주소 형식이 올바르지 않습니다. 예) 192.168.105.101');
        return false;
      }
    }
    return true;
  };

  // 리스트 가져오기
  const fetchAcbList = async () => {
    try {
      const res = await axios.get(`${config.backendUrl}/api/get-acb`);
      const data = res.data;
      setAcbList(Array.isArray(data) ? data : (data ? [data] : []));
    } catch (e) {
      console.error('ACB 조회 실패:', e);
    }
  };

  useEffect(() => {
    fetchAcbList();
  }, []);

  // 추가
  const handleAddClick = async () => {
    const payload = {
      name: inputName,
      protocol: inputProtocol,
      commPort: inputCommPort,
      address: Number(inputAddress),
      ip: isEthernet ? inputIP : null,
      port: isEthernet ? Number(inputPort) : null,
    };

    if (!validateBeforeSave({
      commPort: payload.commPort,
      address: payload.address,
      name: payload.name,
      protocol: payload.protocol,
      ip: payload.ip,
      port: payload.port
    })) return;

    try {
      const resp = await axios.post(`${config.backendUrl}/api/post_acb`, payload);
      if (resp.status === 201 || resp.status === 200) {
        // 다음 편의값 자동 증가
        const nextAddr = String((parseInt(inputAddress || '1', 10) + 1));
        const nextName = `${inputName.replace(/[0-9]+$/, '')}${nextAddr}`;
        setInputAddress(nextAddr);
        setInputName(nextName);
        // IP 자동 증가 제거: 입력한 IP를 유지
        if (isEthernet) setInputIP(inputIP);

        await fetchAcbList();
      } else {
        console.error('ACB 추가 실패:', resp);
      }
    } catch (e) {
      console.error('ACB 추가 중 오류:', e);
      alert('추가 중 오류가 발생했습니다.');
    }
  };

  // 행 클릭(포트 URL 새창)
  const handleRowClick = (commPort) => {
    let url = '';
    switch (commPort) {
      case 'RS485-CH1': url = `${config.backendUrl}/RS485-CH1`; break;
      case 'RS485-CH2': url = `${config.backendUrl}/RS485-CH2`; break;
      case 'RS485-CH3': url = `${config.backendUrl}/RS485-CH3`; break;
      case 'ETHERNET':  url = `${config.backendUrl}/ETHERNET`;  break;
      default: return;
    }
    window.open(url, '_blank');
  };

  // 수정 클릭 → 모달 오픈
  const handleEditClick = (item) => {
    setEditItem({ ...item }); // item: {seq, acb_name, acb_protocol, acb_address, acb_commPort, acb_ethernetIp, acb_ethernetPort, ...}
    setShowModal(true);
    setIsEditing(true);

    // 폼에도 채워 넣기
    setInputCommPort(item.acb_commPort);
    setInputAddress(String(item.acb_address ?? '1'));
    setInputName(item.acb_name ?? '');
    setInputProtocol(item.acb_protocol ?? (Acb_protocollist[0] || 'GIPAM-115FI'));
    setInputIP(item.acb_commPort === 'ETHERNET' ? (item.acb_ethernetIp || '192.168.105.101') : '');
    setInputPort(item.acb_commPort === 'ETHERNET' ? String(item.acb_ethernetPort || '502') : '');
  };

  // 수정 저장
  const handleSaveEdit = async () => {
    if (!editItem) return;

    const payload = {
      name: inputName?.trim(),
      protocol: inputProtocol,
      commPort: inputCommPort,
      address: Number(inputAddress),
      ip: inputCommPort === 'ETHERNET' ? inputIP : null,
      port: inputCommPort === 'ETHERNET' ? Number(inputPort) : null,
    };

    if (!validateBeforeSave({
      commPort: payload.commPort,
      address: payload.address,
      name: payload.name,
      protocol: payload.protocol,
      ip: payload.ip,
      port: payload.port
    })) return;

    try {
      await axios.put(`${config.backendUrl}/api/update_acb/${editItem.seq}`, payload);
      setShowModal(false);
      setIsEditing(false);
      setEditItem(null);
      await fetchAcbList();
    } catch (e) {
      console.error('ACB 수정 실패:', e);
      alert('수정 중 오류가 발생했습니다.');
    }
  };

  // 삭제
  const handleDeleteClick = async (seq, name) => {
    if (!window.confirm(`${name} 을(를) 정말로 삭제하시겠습니까? 삭제 후 복구할 수 없습니다.`)) return;
    try {
      await axios.delete(`${config.backendUrl}/api/delete-acb/${seq}`);
      alert(`${name} : 삭제 완료`);
      await fetchAcbList();
    } catch (e) {
      console.error('ACB 삭제 실패:', e);
      alert('삭제 중 오류가 발생했습니다.');
    }
  };

  // seq → index 매핑 생성
  const seqIndexMap = {};
  acbData.seq?.forEach((s, i) => {
    seqIndexMap[s] = i;
  });

  return (
    <Container className="mt-5">
      <Row className="align-items-center justify-content-center mb-3">
        <Col md="2">
          <Form.Label className="text-center w-100">통신 포트</Form.Label>
          <Form.Control
            as="select"
            value={inputCommPort}
            onChange={(e) => setInputCommPort(e.target.value)}
            className="text-center"
          >
            {commPortList.map((port, index) => (
              <option key={index} value={port}>{port}</option>
            ))}
          </Form.Control>
        </Col>

        {isEthernet && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">IP 주소</Form.Label>
              <Form.Control
                type="text"
                value={inputIP}
                onChange={(e) => setInputIP(e.target.value)}
                className="text-center"
                placeholder="192.168.105.101"
              />
            </Col>
            <Col md="1">
              <Form.Label className="text-center w-100">포트</Form.Label>
              <Form.Control
                type="text"
                value={inputPort}
                onChange={(e) => setInputPort(e.target.value)}
                className="text-center"
                placeholder="502"
              />
            </Col>
          </>
        )}

        <Col md="1">
          <Form.Label className="text-center w-100">장비 ID</Form.Label>
          <Form.Control
            type="text"
            value={inputAddress}
            onChange={(e) => setInputAddress(e.target.value)}
            className="text-center"
          />
        </Col>

        <Col md="2">
          <Form.Label className="text-center w-100">차단기 이름</Form.Label>
          <Form.Control
            type="text"
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
            className="text-center"
          />
        </Col>

        <Col md="2">
          <Form.Label className="text-center w-100">프로토콜 선택</Form.Label>
          <Form.Control
            as="select"
            value={inputProtocol}
            onChange={(e) => setInputProtocol(e.target.value)}
            className="text-center"
          >
            {(Acb_protocollist.length ? Acb_protocollist : ['GIPAM-115FI']).map((p, idx) => (
              <option key={idx} value={p}>{p}</option>
            ))}
          </Form.Control>
        </Col>

        <Col md="2" className="text-center">
          <Button variant="info" onClick={handleAddClick} className="mt-4 w-100">
            ACB 추가
          </Button>
        </Col>
      </Row>

      {/* 포트별 그룹 테이블 */}
      {Array.from(new Set(acbList.map(i => i.acb_commPort))).map((port) => (
        <div key={port}>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={() => handleRowClick(port)} style={{ cursor: 'pointer' }}>{port}</th>
                <th>장비 ID</th>
                <th>차단기 이름</th>
                <th>프로토콜</th>
                {port === 'ETHERNET' && (<><th>IP 주소</th><th>포트</th></>)}
                <th>송신</th>
                <th>수신</th>
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {acbList.map((item, index) => {
                if (item.acb_commPort !== port) return null;
                const idx = seqIndexMap[item.seq];
                return (
                  <tr key={item.seq ?? index}>
                    <td>{index + 1}</td>
                    <td>{item.acb_commPort}</td>
                    <td>{item.acb_address}</td>
                    <td>{item.acb_name}</td>
                    <td>{item.acb_protocol}</td>
                    {port === 'ETHERNET' && (
                      <>
                        <td>{item.acb_ethernetIp || '-'}</td>
                        <td>{item.acb_ethernetPort || '-'}</td>
                      </>
                    )}
         
                    <td>{acbData.sendCount?.[idx] ?? 0}</td>
                    <td>{acbData.receiveCount?.[idx] ?? 0}</td>
                    <td>
                      <Button
                        variant="warning"
                        style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                        onClick={() => handleEditClick(item)}
                      >
                        수정
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        style={{ padding: '5px 5px', fontSize: '10px', lineHeight: '0.8' }}
                        onClick={() => handleDeleteClick(item.seq, item.acb_name)}
                      >
                        삭제
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      ))}

      {/* 수정 모달 */}
      <Modal show={showModal} onHide={() => setShowModal(false)} className="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>ACB 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col style={{ width: '300px' }}>
                <Form.Group>
                  <Form.Label>통신 포트</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputCommPort}
                    onChange={(e) => setInputCommPort(e.target.value)}
                  >
                    {commPortList.map((port, index) => (
                      <option key={index} value={port}>{port}</option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {inputCommPort === 'ETHERNET' && (
                  <>
                    <Form.Group>
                      <Form.Label>IP 주소</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputIP}
                        onChange={(e) => setInputIP(e.target.value)}
                        placeholder="192.168.105.101"
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>포트</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPort}
                        onChange={(e) => setInputPort(e.target.value)}
                        placeholder="502"
                      />
                    </Form.Group>
                  </>
                )}

                <Form.Group>
                  <Form.Label>장비 ID(acb_address)</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputAddress}
                    onChange={(e) => setInputAddress(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>차단기 이름</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>프로토콜 선택</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputProtocol}
                    onChange={(e) => setInputProtocol(e.target.value)}
                  >
                    {(Acb_protocollist.length ? Acb_protocollist : ['GIPAM-115FI']).map((p, idx) => (
                      <option key={idx} value={p}>{p}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => { setShowModal(false); setIsEditing(false); }}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveEdit}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default AcbSetting;
